module.exports = __webpack_public_path__ + "adaguc-logo-favicon-16x16.png";